<!-- Main -->
<div
  class="flex flex-col gap-4 overflow-auto justify-center w-full h-full relative"
  dir="ltr"
  style="direction: ltr"
>
  <!--  <div *ngIf="true" class="absolute-center z-99999">-->
  <!--    <mat-spinner [diameter]="150"></mat-spinner>-->
  <!--  </div>-->
  <ngx-loading [show]="isLoading"></ngx-loading>
  <div id="header" class="absolute top-0 flex flex-row w-full justify-between items-center z-20">
    <!--    Floor name title-->
    <h1 class="text-xl font-bold p-3 mx-3 capitalize text-secondary">
      {{ selectedFloor?.floor_name }}
    </h1>
    <button
      mat-icon-button
      [matTooltip]="'Close' | transloco"
      class="mx-3"
      type="button"
      mat-dialog-close
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <!-- + Floor Details -->
  <div
    class="flex flex-row w-full h-full bg-accent-800 rounded-lg overflow-hidden min-h-100 flx-col items-stretch"
  >
    <!-- + pageMode === 'view' -->

    <div class="debug">{{ dragPosition | json }}</div>
    <div
      #imgContainer
      style="top: 20px"
      class="rounded-md bg-accent-800 mx-auto relative flex-grow w-full"
    >
      <div
        cdkDrag
        #dragableImage
        [cdkDragDisabled]="isAdjustmentMode ? this.adjustPathObj?.isDragging : false"
        [cdkDragFreeDragPosition]="dragPosition"
        (cdkDragMoved)="stopAnimation()"
        (cdkDragEnded)="fixBoundary()"
      >
        <div
          [style.transform]="'translate(-50%, -50%)'"
          [style.height.px]="imgDim.displayH"
          [style.width.px]="imgDim.displayW"
        >
          <!-- snages Section-->
          <div *ngIf="data.type !== 'points'">
            <div
              *ngFor="let observation of observationsList"
              class="observation-point cursor-pointer"
              style="color: #0b172a"
              [class.hidden]="showHideObservations"
              [class.opacity-0]="!ratioBtwImgs"
              [matTooltip]="
                observation.title +
                ' - ' +
                ('Created By:' | transloco) +
                ' ' +
                (observation.creator?.is_system
                  ? observation.creator?.name
                  : (observation.creator?.name | titlecase)) +
                ' - ' +
                ('Significance:' | transloco) +
                ' ' +
                observation.significance_label
              "
              [matTooltipPosition]="'above'"
              [style.left]="
                ((observation.location_x * imgDim.displayW) / imgDim.realW) * ratioBtwImgs?.w + 'px'
              "
              [style.top]="
                ((observation.location_y * imgDim.displayH) / imgDim.realH) * ratioBtwImgs?.h + 'px'
              "
              (click)="openObservation(observation)"
            >
              <img [src]="getObservationIcon(observation)" alt="Note" />
            </div>
          </div>

          <div *ngIf="data.type === 'points' && !isAdjustmentMode" #pointList>
            <!--            <app-navigation [zoomMap]="true"></app-navigation>-->
            <div
              *ngFor="let point of points"
              class="observation-point cursor-pointer"
              style="color: #0b172a"
              [class.opacity-0]="!ratioBtwImgs"
              [style.maxWidth]="_pano.fullPath ? '25px' : 'inital'"
              [style.maxHeight]="_pano.fullPath ? '25px' : 'inital'"
              [style.left]="
                point.point_x
                  | floorPointSize
                    : isVideoReport
                    : imgDim.displayW
                    : imgDim.realW
                    : ratioBtwImgs?.w
                    : 'x'
              "
              [style.top]="
                point.point_y
                  | floorPointSize
                    : isVideoReport
                    : imgDim.displayH
                    : imgDim.realH
                    : ratioBtwImgs?.h
                    : 'y'
              "
              [style.transform]="
                'scale(' +
                (isVideoReport
                  ? 1
                  : selectedReport.report_type === REPORT_TYPE
                  ? 1.3
                  : 1 * (imgDim.displayW / imgDim.realW)) +
                ')'
              "
              [style.transform-origin]="'top left'"
              (click)="changePoint(point)"
              [matTooltip]="point?.point_name | titlecase"
              matTooltipPosition="above"
            >
              <div
                #pointList
                id="point_list"
                class="point-icon"
                [ngClass]="{
                  'selected-starred':
                    point.is_selected_point === 1 &&
                    point.point_id === _project.currentPImg.point_id,
                  selected:
                    point.is_selected_point !== 1 &&
                    point.point_id === _project.currentPImg.point_id,
                  starred: point.is_selected_point === 1,
                  default: point.is_selected_point !== 1
                }"
              ></div>
            </div>
          </div>

          <div id="svg-container">
            <div id="points-div" *ngIf="isAdjustmentMode"></div>
            <svg
              id="my-svg"
              width="100%"
              height="100%"
              xmlns="http://www.w3.org/2000/svg"
              *ngIf="isAdjustmentMode"
              preserveAspectRatio="xMidYMid"
            >
              <!--              <defs>-->
              <!--                <pattern id="image" x="0" y="0" patternUnits="userSpaceOnUse" height="15" width="16">-->
              <!--                  <image x="0" y="0" xlink:href="/assets/images/refresh.png" width="10" height="10"></image>-->
              <!--                </pattern>-->
              <!--              </defs>-->
              <!-- Your SVG content will be added here -->
            </svg>
            <img
              draggable="false"
              #floorImgElm
              [src]="floorImg"
              style="height: 100%; width: 100%"
              (mousedown)="onMouseDown($event)"
              (mouseup)="addPoint($event)"
              class="rounded-md"
              [class.floor-img]="canAddObservation"
              [class.cursor-move]="!canAddObservation"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row w-1/2 justify-center self-center p-2 flex-grow">
    <div class="rounded-2xl px-3 bg-accent-900 bg-opacity-50 flx-row items-center">
      <button
        mat-icon-button
        [matTooltip]="'Reset Position' | transloco"
        type="button"
        (click)="resetImgSizeAndPosition()"
      >
        <mat-icon color="primary" svgIcon="center_focus_weak"></mat-icon>
      </button>

      <button
        mat-icon-button
        [matTooltip]="'Zoom Out' | transloco"
        type="button"
        (click)="zoom('out')"
      >
        <mat-icon color="primary" svgIcon="zoom_out"></mat-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="'Zoom In' | transloco"
        type="button"
        (click)="zoom('in')"
      >
        <mat-icon color="primary" svgIcon="zoom_in"></mat-icon>
      </button>
      <mat-slider
        [dir]="_transloco.getActiveLang() === 'ar' ? 'rtl' : 'ltr'"
        style="height: 50px; display: block"
        color="primary"
        class="w-full"
        [min]="imgScaleDefault"
        [max]="400"
        [(value)]="imgScale"
        (input)="onScaleSlider($event)"
        (valueChange)="onScaleSliderAdjustment($event)"
      >
      </mat-slider>

      <!--temp code for operation engineer-->
      <button
        mat-icon-button
        [matTooltip]="'Adjust Path' | transloco"
        type="button"
        (click)="activateAdjustMode()"
        *ngIf="!isAdjustmentMode && _project.isOperationEngineer()"
      >
        <mat-icon color="primary" svgIcon="control_camera"></mat-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="'Reset' | transloco"
        type="button"
        (click)="cancelAdjustments()"
        *ngIf="isAdjustmentMode && _project.isOperationEngineer()"
      >
        <mat-icon color="primary" svgIcon="undo"></mat-icon>
      </button>
      <button
        *ngIf="_project.isOperationEngineer()"
        mat-icon-button
        [matTooltip]="'Confirm' | transloco"
        type="button"
        (click)="confirmFloor()"
      >
        <mat-icon color="primary" svgIcon="check"></mat-icon>
      </button>
      <button
        (click)="openRejectFloorPopup()"
        *ngIf="_project.isOperationEngineer()"
        [matTooltip]="'Reject' | transloco"
        mat-icon-button
        type="button"
      >
        <mat-icon [svgIcon]="'heroicons_solid:x'" color="warn"></mat-icon>
      </button>
      <!--temp code for operation engineer-->
    </div>
    <div
      *ngIf="data.type !== 'points'"
      class="flex flex-row rounded-xl px-1 h-full items-center p-1 mx-3"
    >
      <app-toolbar-btn
        class="showHideObservations"
        (myClick)="showHideObservations = !showHideObservations"
        [onOff]="showHideObservations"
        icon="mat_solid:speaker_notes"
        [hint]="'Show/Hide Observations' | transloco"
        innerIconOff="heroicons_outline:eye"
        innerIconOn="heroicons_outline:eye-off"
        [switch]="true"
        [innerIcon]="true"
      >
        {{ 'Show/Hide Observations' | transloco }}
      </app-toolbar-btn>
    </div>
    <div
      *ngIf="data.type !== 'points'"
      class="flex flex-row rounded-xl px-1 items-center p-1 mx-3 bg-primary-800"
      [class.bg-opacity-70]="!canAddObservation && !getAddObservationOnFloorPlanPermission()"
    >
      <button
        mat-icon-button
        [disabled]="!getAddObservationOnFloorPlanPermission()"
        [matTooltip]="'Add Floor Observation' | transloco"
        type="button"
        (click)="
          canAddObservation = true;
          googleServices.setEvent('OpenFloorObservations_AddObservation_projects', 'Interactivity');
          checkFloorAndPoint()
        "
      >
        <mat-icon color="accent" svgIcon="add"></mat-icon>
      </button>
    </div>
  </div>
</div>
